import React, { useState, useEffect } from 'react';
import { Box, Button, CircularProgress, Paper, Typography, ThemeProvider, createTheme } from '@mui/material';

const AccessDeniedPage = () => {
    const [countdown, setCountdown] = useState(3);
    const navigateTo = process.env.REACT_APP_COCKPIT_URL || '/';

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        const redirectTimer = setTimeout(() => {
            // Garante que só redireciona se a URL estiver definida
            if (navigateTo && navigateTo !== '/') {
                window.location.href = navigateTo;
            }
        }, 3000);

        return () => {
            clearInterval(timer);
            clearTimeout(redirectTimer);
        };
    }, [navigateTo]);

    return (
        <ThemeProvider theme={createTheme({ palette: { mode: 'dark' } })}>
            <Box
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center', backgroundColor: '#050a30', p: 2 }}
            >
                <Paper
                    elevation={12}
                    sx={{ p: 4, background: 'rgba(25, 35, 55, 0.7)', backdropFilter: 'blur(10.0px)', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.18)', maxWidth: '500px' }}
                >
                    <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#ff834f', fontWeight: 'bold' }}>Acesso Negado</Typography>
                    <Typography variant="body1" sx={{ mb: 2, color: 'rgba(255, 255, 255, 0.9)' }}>Você precisa estar autenticado para acessar esta página.</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, mb: 3 }}>
                        <CircularProgress size={20} sx={{ color: '#ff834f' }} />
                        <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                            Redirecionando para a plataforma principal em {countdown > 0 ? `${countdown} segundos` : 'agora'}...
                        </Typography>
                    </Box>
                    <Button variant="contained" href={navigateTo} sx={{ backgroundColor: '#ff834f', '&:hover': { backgroundColor: '#e67342' } }}>
                        Se não for redirecionado, clique aqui
                    </Button>
                </Paper>
            </Box>
        </ThemeProvider>
    );
};

export default AccessDeniedPage;